export const COLLECTION_TAB_FAILURE = 'COLLECTION_TAB_FAILURE';
export const OPEN_COLLECTION_TAB = 'OPEN_COLLECTION_TAB';
export const SWITCH_COLLECTION_TABS = 'SWITCH_COLLECTION_TABS';
